import { get, post, put, del } from "../client";
import {
  CREATE_SERVICE,
  DELETE_SERVICE,
  GET_ALL_SERVICES,
  GET_SERVICES,
  GET_SERVICE_BY_ID,
  UPDATE_SERVICE,
  GET_SERVICE_CATEGORIES,
  CREATE_SERVICE_CATEGORY,
  GET_ALL_PRODUCTS,
} from "../routes";

export default {
  get_all: async (data) => await post(GET_ALL_SERVICES, data),

  get: async (id) => await get(GET_SERVICES(id)),

  get_by_id: async (id) => await get(GET_SERVICE_BY_ID(id)),

  update: async (data) => await put(UPDATE_SERVICE, data),

  create: async (data) => await post(CREATE_SERVICE, data),

  del: async (id) => await del(DELETE_SERVICE(id)),

  // Service categories
  get_categories: async () => await get(GET_SERVICE_CATEGORIES),

  create_category: async (data) => await post(CREATE_SERVICE_CATEGORY, data),

  // Products
  get_all_products: async () => await get(GET_ALL_PRODUCTS),
};
